import React from "react";
import { BRAND } from "../config/brand";

/* ================================================================
   카카오톡 문의 플로팅 버튼 (전 클론 사이트 공통)
   - 모든 사이트가 BRAND.kakaoUrl 하나의 채널로 연결 → "문의는 한 곳으로".
   - kakaoUrl 미설정이면 렌더링하지 않음(자리표시자 안전 처리).
   ================================================================ */
export default function KakaoButton() {
  const url = BRAND.kakaoUrl;
  if (!url) return null;
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="카카오톡 문의하기"
      style={{
        position: "fixed",
        right: 20,
        bottom: 20,
        zIndex: 60,
        display: "inline-flex",
        alignItems: "center",
        gap: 8,
        padding: "12px 18px",
        background: "#FEE500",
        color: "#191600",
        fontSize: 14,
        fontWeight: 700,
        borderRadius: 999,
        textDecoration: "none",
        boxShadow: "0 10px 28px -8px rgba(0,0,0,0.35)",
      }}
    >
      <svg width="20" height="20" viewBox="0 0 24 24" fill="#191600" aria-hidden="true">
        <path d="M12 3C6.477 3 2 6.59 2 11.02c0 2.86 1.94 5.37 4.86 6.78-.21.74-.77 2.69-.88 3.11-.14.53.19.52.4.38.17-.11 2.66-1.81 3.74-2.55.61.09 1.24.13 1.88.13 5.523 0 10-3.59 10-8.02S17.523 3 12 3z" />
      </svg>
      카카오톡 문의
    </a>
  );
}
